module.exports = __webpack_public_path__ + "connectivity-white.svg?8805ca15647acf2424fbbb3fec7706cc";